module.exports = __webpack_public_path__ + "img/scanning.86bf7c6b.png";